var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"size":"20","color":"light-blue darken-4"}},[_vm._v(_vm._s(this.icon))])],1),_c('v-list-item-title',[_vm._v(_vm._s(this.title))]),_c('v-list-item-subtitle',[_vm._v(_vm._s(this.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }